import React from 'react';

const TableBody = ({
  config,
  data,
  sortField,
  sortDirection,
  handleSort,
  selectedRows,
  handleRowSelect,
  handleSelectAll,
  onView,
  onEdit,
  onReport,
  onDelete,
  onStatusCheck
}) => {
  // Format currency
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || amount === '') return 'N/A';
    const numAmount = parseFloat(amount);
    if (isNaN(numAmount)) return 'N/A';
    return `₹${numAmount.toFixed(2)}`;
  };

  // Format cell value based on column type
  const formatCellValue = (value, column) => {
    if (!value && value !== 0) return 'N/A';
    
    switch (column.type) {
      case 'currency':
        return formatCurrency(value);
      case 'badge':
        return (
          <span className={`badge ${column.badgeClass?.(value) || 'bg-secondary'}`}>
            {column.transform ? column.transform(value) : value.toString().toUpperCase()}
          </span>
        );
      case 'link':
        return <span className="f-w-500 text-primary">#{value}</span>;
        case "image":
          return (
            <img
            src={`https://pro.mokshiq.in/media/${column.transform ? column.transform(value) : value}`}
              alt={  "image"}
              style={{ height: "40px", width: "40px", objectFit: "contain", borderRadius: "4px" }}
            />
          );
      case 'text':
      default:
        return column.transform ? column.transform(value) : value;
    }
  };

  return (
    <div className="card-body p-0">
      <div className="table-responsive app-scroll">
        <table className="table table-bottom-border table-box-hover align-middle mb-0">
          <thead>
            <tr>
              <th>
                <label className="check-box">
                  <input
                    type="checkbox"
                    checked={selectedRows.length === data.length && data.length > 0}
                    onChange={handleSelectAll}
                  />
                  <span className="checkmark outline-light ms-2"></span>
                </label>
              </th>
              {config.columns.map((column) => (
                <th
                  key={column.key}
                  onClick={() => column.sortable !== false && handleSort(column.key)}
                  style={{ cursor: column.sortable !== false ? 'pointer' : 'default' }}
                  className={column.sortable !== false ? 'user-select-none' : ''}
                >
                  {column.label}
                  {column.sortable !== false && sortField === column.key && (
                    <i className={`ms-1 iconoir-nav-arrow-${sortDirection === 'asc' ? 'up' : 'down'}`}></i>
                  )}
                </th>
              ))}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr 
                key={item.id || item[config.idField]} 
                className={selectedRows.includes(item.id || item[config.idField]) ? 'bg-light-primary' : ''}
              >
                <td>
                  <label className="check-box">
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(item.id || item[config.idField])}
                      onChange={() => handleRowSelect(item.id || item[config.idField])}
                    />
                    <span className="checkmark outline-light ms-2"></span>
                  </label>
                </td>
                
                {config.columns.map((column) => (
                  <td
                    key={column.key}
                    className={column.className || ''}
                    style={{ userSelect: 'text', WebkitUserSelect: 'text' }}
                  >
                    {formatCellValue(item[column.key], column)}
                  </td>
                ))}
                
                <td>
                  <div className="d-flex gap-1">
                    {config.actions?.view !== false && (
                      <button 
                        className="btn btn-primary icon-btn b-r-4" 
                        type="button" 
                        title="View"
                        onClick={() => onView(item)}
                      >
                        <i className="iconoir-eye"></i>
                      </button>
                    )}
                    {config.actions?.edit !== false && (
                      <button 
                        className="btn btn-success icon-btn b-r-4" 
                        type="button" 
                        title="Edit"
                        onClick={() => onEdit(item)}
                      >
                        <i className="iconoir-edit"></i>
                      </button>
                    )}
                    {config.actions?.delete !== false && (
                      <button 
                        className="btn btn-danger icon-btn b-r-4" 
                        type="button" 
                        title="Delete"
                        onClick={() => onDelete(item)}
                      >
                        <i className="iconoir-trash"></i>
                      </button>
                    )}
                   {onReport && (
  <button 
    className="btn btn-primary icon-btn b-r-4" 
    type="button" 
    title="View Report"
    onClick={() => onReport(item)}
  >
    <i className="iconoir-graph-up"></i>
  </button>
)}
{onStatusCheck && (
  <button 
    className="btn btn-warning icon-btn b-r-4" 
    type="button" 
    title="Check Status"
    onClick={() => onStatusCheck(item)}
  >
    <i className="iconoir-refresh-circle"></i>
  </button>
)}
                  </div>
                </td>
              </tr>
            ))}
            
            {data.length === 0 && (
              <tr>
                <td colSpan={config.columns.length + 2} className="text-center py-4">
                  <div>
                    <i className="iconoir-search f-s-48 text-secondary mb-3"></i>
                    <h6 className="text-secondary">No records found</h6>
                    <p className="text-secondary f-s-14">Try adjusting your search or filter criteria</p>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableBody;